import { Injectable, inject } from "@angular/core";
import {
    LogexPivotService,
    ILogexPivotDefinition,
    PivotProviderBase
} from "@logex/framework/lg-pivot";
import {
    PivotBRDetailProduct,
    PivotBRDetailInstance,
    PivotBRDetailRole
} from "./business-role-detail-pivot.types";
import { SharedDefinitions } from "@mrdm-self-service-frontend/shared/data-access-definitions";
import { ApplicationRole } from "../../../../shared/types";
import { BusinessRoleDetailDialogComponent } from "../business-role-detail-dialog.component";
import { getAppRoleKey } from "apps/administration/src/app/shared/helpers/application-role-key";
import {
    getRoleLevel,
    getSortName
} from "apps/administration/src/app/shared/helpers/application-role-hierarchy";

// ----------------------------------------------------------------------------------
//
@Injectable()
export class BusinessRoleDetailPivot extends PivotProviderBase {
    private _definitions = inject(SharedDefinitions);


    getPivotDefinition(): ILogexPivotDefinition {
        return <ILogexPivotDefinition>{
            column: "productCode",
            levelId: "product",
            defaultOrderBy: "name",
            store: "products",
            filteredStore: "products",
            attachedColumns: [
                (node: PivotBRDetailProduct, row: ApplicationRole) => {
                    node.name = this._definitions.product[row.productCode].name;
                    node.$expanded = true;
                }
            ],
            children: {
                column: "applicationInstanceCode",
                levelId: "applicationInstance",
                defaultOrderBy: "name",
                store: "applicationInstances",
                filteredStore: "applicationInstances",
                attachedColumns: [
                    (node: PivotBRDetailInstance, row: ApplicationRole) => {
                        node.name =
                            this._definitions.applicationInstance[row.applicationInstanceCode].name;
                        node.$expanded = true;
                    }
                ],
                children: {
                    column: "applicationRoleCode",
                    levelId: "applicationRole",
                    defaultOrderBy: "sortName",
                    store: "applicationRoles",
                    filteredStore: "applicationRoles",
                    attachedColumns: [
                        (
                            node: PivotBRDetailRole,
                            row: ApplicationRole,
                            _parent,
                            ctx: BusinessRoleDetailDialogComponent
                        ) => {
                            const appRole =
                                this._definitions.applicationRole[row.applicationRoleCode];
                            node.name = appRole?.name;
                            node.description = appRole?.description || "";

                            const availableRole = ctx._availableAppRoles[getAppRoleKey(row)];
                            node.level = getRoleLevel(availableRole, ctx._availableAppRoles);
                            node.sortName = getSortName(
                                availableRole,
                                ctx._availableAppRoles,
                                this._definitions
                            );
                        }
                    ]
                }
            }
        };
    }
}
